<template>
  <div
    v-if="!isRoutingActive"
    id="setting-buttons-wrapper"
    :class="{
      'setting-buttons--secondary': isSecondaryInstance,
      'map-weather': isWeatherActive,
    }"
  >
    <!-- <div class="button-block top-section" v-if="!isRoutingActive && !$root.$data.embedded" > -->
    <div class="button-block top-section" v-if="!isRoutingActive">
      <button
        v-if="is3DActive"
        class="material-icons-round md-20 weather-bottom"
        :class="{active: isWeatherActive}"
        :title="$t('buttons.weather3D')"
        @click="handleWeatherClick"
      >
        thunderstorm
      </button>

      <button
        v-if="!is3DActive && !$root.$data.embedded"
        class="icon-img-layers weather-bottom desktop-only"
        :class="{active: currentComponent === 'Layers'}"
        :title="$t('LayersControl')"
        @click="toggleFrame('Layers')"
      >
        layers
      </button>
    </div>
    <div class="material-icons-round md-20 launch-bottom" v-if="$root.$data.embedded">
      <button class="material-icons-round md-20" :title="$t('buttons.popout')" @click="popout">launch</button>
    </div>

    <!-- <div class="button-block top-section" v-if="!$root.$data.embedded && !isRoutingActive">
      <button
        v-if="!is3DActive"
        class="material-icons-round md-20 desktop-only"
        :class="{active: currentComponent === 'Layers'}"
        :title="$t('LayersControl')"
        @click="toggleFrame('Layers')"
      >
        layers
      </button>
    </div> -->

    <div id="setting-buttons" class="middle-section" v-if="!$root.$data.embedded && !isRoutingActive">
      <!-- frontend2-base dezactivat butonul de layers SF-->
      <button v-if="is3DActive" class="md-20" :title="$t('LayersControl')" @click="toggleLayers">
        <img :src="layersIcon" alt="Layers" class="icon-img" />
      </button>

      <button v-if="!is3DActive" :title="$t('buttons.view3D')" @click="open3DView">
        <img :src="mtkMapIcon" alt="Layers" class="icon-img-mtk" />
      </button>

      <!-- frontend2-base dezactivat butonul de layers SF-->

      <!-- <button
        v-if="!$root.$data.embedded "
        class="material-icons-round md-20 desktop-only"
        :class="{active: currentComponent === 'Layers'}"
        :title="$t('LayersControl')"
        @click="toggleFrame('Layers')"
      >
        layers
      </button> -->

      <button
        v-if="!$root.$data.embedded"
        class="material-icons-round md-20"
        :class="{active: geolocationEnabled}"
        :title="$t('buttons.gps')"
        @click="handleGeolocationToggle"
      >
        gps_fixed
      </button>

      <button
        v-if="$root.$data.embedded"
        class="material-icons-round md-20"
        :title="$t('buttons.popout')"
        @click="popout"
      >
        launch
      </button>

      <FullScreenControl v-if="!$root.$data.embedded" />
      <button
        v-if="!$root.$data.embedded"
        class="material-icons-round md-20"
        :class="{active: currentComponent === 'Settings'}"
        :title="$t('SettingsControl')"
        @click="toggleFrame('Settings')"
      >
        settings
      </button>
    </div>

    <!-- <div class="button-block bottom-section" v-if="!$root.$data.embedded && !isRoutingActive" >
      <button
        v-if="is3DActive"
          class="material-icons-round md-20 weather-bottom"
          :class="{ active: isWeatherActive }"
          :title="$t('buttons.weather3D')"
          @click="handleWeatherClick"

        >
          thunderstorm
      </button>
      <button
        v-if="!is3DActive"
        class="text-button"
        :title="$t('buttons.view3D')"
        @click="open3DView"
      >
        3D
      </button>
    </div> -->

    <ControlPopup :currentName="currentComponent" @closeFrame="closeFrame" />
  </div>
</template>

<script>
import FullScreenControl from "./FullScreenControl";
import ControlPopup from "./ControlPopup";
import EmbedHelper from "../../services/embedHelper";
import Geolocation from "ol/Geolocation";
import {basemap} from "../../services/map/basemap";
import Feature from "ol/Feature";
import Style from "ol/style/Style";
import CircleStyle from "ol/style/Circle";
import Fill from "ol/style/Fill";
import Point from "ol/geom/Point";
import {Vector as VectorSource} from "ol/source";
import {Vector as VectorLayer} from "ol/layer";
import ZIndex from "../../services/zindex";
import Stroke from "ol/style/Stroke";
import {easeOut} from "ol/easing";
import layersIcon from "@/assets/icons/layers.png";
// import mtkMapIcon from "@/assets/icons/3D.png";
import mtkMapIcon from "@/assets/icons/01.png";
// import mtkMapIcon from "@/assets/icons/02.png";
// import mtkMapIcon from "@/assets/icons/03.png";
export default {
  name: "SettingButtonsComponent",
  props: {
    isWeatherActive: {
      type: Boolean,
      default: false,
    },
    is3DActive: {
      type: Boolean,
      default: false,
    },
    isRoutingActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {ControlPopup, FullScreenControl},
  data() {
    return {
      currentComponent: null,
      geolocationEnabled: false,
      geolocation: null,
      isSecondaryInstance: false,
      layersIcon,
      mtkMapIcon,
      isWeatherOn: false,
    };
  },
  watch: {
    isRoutingActive(newVal) {
      console.log("Routing state changed in SettingButtons:", newVal);
    },
    geolocationEnabled(enabled) {
      if (this.geolocation === null) {
        this.setupGeolocation();
      }

      this.geolocation.gl.setTracking(enabled);

      if (enabled) {
        basemap.map.addLayer(this.geolocation.layer);
      } else if (this.geolocation.layer !== null) {
        basemap.map.removeLayer(this.geolocation.layer);
      }
    },
  },

  methods: {
    handleGeolocationToggle() {
      if (this.is3DActive) {
        this.geolocationEnabled = !this.geolocationEnabled;
        // Geolocation for MapToolkit
        this.locateInMapToolkit();
      } else {
        // Geolocation for OpenLayers (OL)
        this.geolocationEnabled = !this.geolocationEnabled;
      }
    },

    locateInMapToolkit() {
      console.log(" locateInMapToolkit() called – emitting triggerGeolocationIn3D");
      this.$emit("triggerGeolocationIn3D");
    },
    toggleLayers() {
      this.$emit("forceCloseWeather");
      this.$emit("forceClose3D");
      // this.toggleFrame('Layers');
    },

    toggleFrame(component) {
      // this.$emit("forceCloseWeather");
      // this.$emit("forceClose3D");
      this.$emit("clearRouting");
      this.currentComponent = this.currentComponent === component ? null : component;
    },
    closeFrame() {
      this.currentComponent = null;
    },
    open3DView() {
      this.$emit("clearRouting");

      const isMobile = window.matchMedia("(max-width: 600px)").matches;
      const isEmbedded = !!this.$root.$data.embedded;

      this.$emit("openMap3DView");

      if (!isMobile || isEmbedded) return;

      const tocId = (this.$route?.query?.["toc-id"] || "").toString().trim();
      const hasToc = tocId !== "";

      this.$nextTick(() => {
        setTimeout(() => {
          if (hasToc) {
            //cats-expanded + cats-overlay-on + cats-has-toc
            this.$root.$emit("openCategoriesMenu", {forceOverlay: true});
          } else {
            //  cats-no-toc + cats-compact
            this.$root.$emit("categoriesToCompact", {overlayOnNextOpen: false});

            // clean URL
            const q = {...(this.$route?.query || {})};
            delete q["toc-id"];
            delete q["parent"];
            this.$router.replace({query: q}).catch(() => {});
          }
        }, 0);
      });
    },
    close3D() {
      this.$emit("forceCloseWeather");
      this.$emit("forceClose3D");
    },
    setupGeolocation() {
      const map = basemap.map;
      const geolocation = new Geolocation({
        trackingOptions: {enableHighAccuracy: true},
        projection: map.getView().getProjection(),
      });

      const accuracy = new Feature();
      const position = new Feature();
      position.setStyle(
        new Style({
          image: new CircleStyle({
            radius: 6,
            fill: new Fill({color: "#3399CC"}),
            stroke: new Stroke({color: "#fff", width: 2}),
          }),
        })
      );

      geolocation.on("change:accuracyGeometry", () => {
        accuracy.setGeometry(geolocation.getAccuracyGeometry());
      });

      geolocation.on("change:position", () => {
        const coordinates = geolocation.getPosition();
        position.setGeometry(coordinates ? new Point(coordinates) : null);
      });

      geolocation.once("change:position", () => {
        const coordinates = geolocation.getPosition();
        map.getView().animate({
          center: coordinates,
          duration: 500,
          easing: easeOut,
        });
      });

      geolocation.on("error", (error) => {
        console.log(error.message);
        this.geolocationEnabled = false;
      });

      const vectorSource = new VectorSource({features: [accuracy, position]});
      const layer = new VectorLayer({
        source: vectorSource,
        crossOrigin: "anonymous",
        updateWhileAnimating: true,
        updateWhileInteracting: true,
      });

      layer.setZIndex(ZIndex.Marker);
      this.geolocation = {gl: geolocation, layer: layer};
    },
    popout() {
      const target = EmbedHelper.getStandalone();
      const win = window.open(target, "_blank");
      win.focus();
    },
    // zoomIn() {
    //   const view = basemap.map.getView();
    //   view.setZoom(view.getZoom() + 1);
    // },
    // zoomOut() {
    //   const view = basemap.map.getView();
    //   view.setZoom(view.getZoom() - 1);
    // },
    openWeatherMTK() {
      if (this.is3DActive) {
        console.log("Toggling weather ON/OFF inside 3D view...");
        this.$emit("toggleWeatherLayer");
      } else {
        console.log("3D map is NOT active – starting 3D map with weather OFF");
        this.$emit("clearRouting");
        this.$emit("openMap3DView");
      }
    },
    // open3DViews() {
    //   this.$emit("clearRouting");
    //   this.$emit("openMap3DView");
    // },
    handleWeatherClick() {
      console.log("handleWeatherClick – toggling weather");

      const group = document.querySelector(".mtk-weather-control-group");
      if (!group) return;

      group.style.display = "inline-flex";
      group.style.flexDirection = "column";

      const overviewBtn = group.querySelector(".mtk-weather-control-overview-button");

      const precipitationBtn = group.querySelector(".mtk-weather-control-precipitation-button");
      if (precipitationBtn) {
        precipitationBtn.click();
      }

      this.isWeatherOn = !this.isWeatherOn;

      if (this.isWeatherOn) {
        console.log("WEATHER ON");
        if (overviewBtn) {
          overviewBtn.click();
        }
      } else {
        console.log("WEATHER OFF");
        if (overviewBtn) {
          overviewBtn.click();
        }
      }

      this.$emit("toggleWeatherLayer", this.isWeatherOn);
    },
  },
};
</script>
<style lang="css">
.icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 3.5px;
}

.icon-img-mtk {
  /* width: 23px; */
  /* height: 25px; */
  width: 30px;
  height: 30px;
  /* object-fit: contain; */
  border-radius: 3.5px;
}

.icon-img-layers {
  width: 30px;
  height: 30px;
  object-fit: contain;
  border-radius: 3.5px;
}
</style>

 <style lang="scss" scoped>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons+Round");

#setting-buttons-wrapper {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  z-index: 2;
  pointer-events: auto;

  &.map-routing {
    z-index: 0 !important;
  }

  &.map-weather {
    z-index: 4 !important;
  }
}

.button-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top-section {
  margin-right: 3px;
  background-color: #ecf0f3;
  border: 1px solid #a9a9a9;
  box-shadow: 2px 2px 4px #9999;
  border-radius: 12px;
  margin-bottom: 2.5px;
}
.middle-section {
  margin-right: 3px;
  padding: 2.5px !important;
  gap: 2px !important;
}
.bottom-section {
  background-color: #ecf0f3;
  border: 1px solid #a9a9a9;
  box-shadow: 2px 2px 4px #9999;
  border-radius: 12px;
  margin-right: 4px;
  margin-bottom: 16px;
}

.text-button {
  font-family: Quicksand, sans-serif;
  background-color: #ecf0f3;
  font-size: 16px;
  font-weight: 900;
  background-color: #ecf0f3;
  color: #444;
  font-weight: bold;
  font-size: 14px;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

#setting-buttons {
  background-color: #ecf0f3;
  border-radius: 12px;
  padding: 6px;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 6px;
}

#setting-buttons button {
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  font-family: "Material Icons Round", sans-serif;
  font-size: 22px;
  color: #444;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
}

#setting-buttons button:hover {
  background-color: #ecf0f316;
  transform: scale(1.05);
}

#setting-buttons button.active {
  color: #181a1d;
  background-color: #ecf0f3;
}

.weather-bottom {
  width: 42px;
  height: 40px;
  border-radius: 12px;
  font-family: "Material Icons Round", sans-serif;
  font-size: 22px;
  color: #444;
}
.launch-bottom {
  width: 42px;
  height: 40px;
  border-radius: 12px;
  font-family: "Material Icons Round", sans-serif;
  font-size: 22px;
  color: #444;
  display: flex; /* IMPORTANT */
  align-items: center; /* vertical */
  justify-content: center; /* orizontal */
  background-color: #ecf0f3;
  border: 1px solid #a9a9a9;
  box-shadow: 2px 2px 4px #9999;
  border-radius: 12px;
  margin-bottom: 2.5px;
  justify-content: center !important;
  align-items: center;
}
</style>
